import { put, takeLatest, call } from 'redux-saga/effects';

import {
  getWorshipLocationsSuccess,
  getWorshipLocationByIdSuccess,
} from '../actionCreators/worshipLocationsActions';
import {
  GET_WORSHIP_LOCATIONS_REQUEST,
  GET_WORSHIP_LOCATION_BY_ID_REQUEST,
} from '../constants/actionTypes';
import { WorshipLocationsApi } from '../api';
import errorHandler from '../utils/requestErrorHandler';

function* getWorshipLocations(action) {
  try {
    const data = yield call(WorshipLocationsApi.getWorshipLocations, action.payload);

    yield put(getWorshipLocationsSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* getWorshipLocationById(action) {
  try {
    const data = yield call(WorshipLocationsApi.getWorshipLocationById, action.payload);

    yield put(getWorshipLocationByIdSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

export default function* watchChallenge() {
  yield takeLatest(GET_WORSHIP_LOCATIONS_REQUEST, getWorshipLocations);
  yield takeLatest(GET_WORSHIP_LOCATION_BY_ID_REQUEST, getWorshipLocationById);
}
